"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FromLong_1 = require("./FromLong");
var NetworkAddress_1 = require("./NetworkAddress");
var ToLong_1 = require("./ToLong");
function firstHost(subnet) {
    var longFirstHost = ToLong_1.toLong(NetworkAddress_1.networkAddress(subnet)) + 1;
    return FromLong_1.fromLong(longFirstHost);
}
exports.firstHost = firstHost;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmlyc3RIb3N0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiRmlyc3RIb3N0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsdUNBQXFDO0FBQ3JDLG1EQUFpRDtBQUNqRCxtQ0FBaUM7QUFFakMsbUJBQTJCLE1BQWM7SUFDdkMsSUFBSSxhQUFhLEdBQUcsZUFBTSxDQUFDLCtCQUFjLENBQUMsTUFBTSxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUE7SUFDdEQsTUFBTSxDQUFDLG1CQUFRLENBQUMsYUFBYSxDQUFDLENBQUE7QUFDaEMsQ0FBQztBQUhELDhCQUdDIn0=


//////////////////
// WEBPACK FOOTER
// ./src/FirstHost.ts
// module id = 9
// module chunks = 0